module.exports = __webpack_public_path__ + "static/media/scotia.c1996a13.png";